import {useEffect} from 'react';
import {useTranslation} from 'react-i18next';

export const useSyncLanguage = () => {
  const {i18n} = useTranslation();

  useEffect(() => {
    const syncLanguageAttributes = (lng: string) => {
      if (!lng) return;
      document.documentElement.lang = lng;
      // In the future, if RTL languages are supported, set dir dynamically
      // Example: document.documentElement.dir = i18n.dir(lng);
      document.documentElement.dir = i18n.dir(lng) || 'ltr';
    };

    // Sync initially
    syncLanguageAttributes(i18n.language);

    // Subscribe to language changes
    i18n.on('languageChanged', syncLanguageAttributes);

    return () => {
      i18n.off('languageChanged', syncLanguageAttributes);
    };
  }, [i18n]);
};

export default useSyncLanguage;
